"use client";

import { useModalSequence } from "@/providers/modal-sequence";
import { useCallback } from "react";

export function useRelationshipSelection() {
	const { isRelationshipModalActive, completeRelationshipModal } = useModalSequence();

	const markSelectionShown = useCallback(() => {
		completeRelationshipModal();
	}, [completeRelationshipModal]);

	const hideSelection = useCallback(() => {
		completeRelationshipModal();
	}, [completeRelationshipModal]);

	return {
		shouldShowSelection: isRelationshipModalActive,
		markSelectionShown,
		hideSelection,
	};
}
